<!-- CONTENT CARD -->

<div id="entity" class="content-card flex flex-col h-full" *ngIf="entity">
    <div class="header accent flex justify-between items-center p-4">
        <span class="text-4xl font-semibold text-white">{{entity.name}}</span>
        <button mat-raised-button *ngIf="entity && _systemService.canAction('adminProjects')"
                [disabled]="entityForm.pristine && this.entity && !this.entity.estimationChanged" (click)="saveEntity()">
            <mat-icon>save</mat-icon>
            <span>Guardar</span>
        </button>
    </div>
    <!--    <div class="datatable-header">-->

    <!--        <button mat-raised-button *ngIf="entity && _systemService.canAction('adminProjects')"-->
    <!--                class="accent" [disabled]="entityForm.pristine" (click)="saveEntity()">-->
    <!--            <span>Guardar</span>-->
    <!--        </button>-->
    <!--    </div>-->
    <!-- CONTENT -->
    <div *ngIf="entity" class="content overflow-auto p-4">

        <form name="entityForm" [formGroup]="entityForm" class="w-full flex flex-col">
            <div class="tab-content">
                <div class="flex flex-col bg-white shadow-sm border border-slate-200 rounded-lg w-full">
                    <div class="mx-3 mb-0 border-slate-200 pt-3 pb-2 px-1">
                        <span class="text-4xl text-slate-600 font-normal">
                            Datos básicos
                        </span>
                    </div>

                    <div class="flex flex-wrap pt-2 pr-4">
                        <!-- Nombre -->
                        <mat-form-field dense appearance="outline" floatLabel="always" class="pl-4 sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5">
                            <mat-label>Nombre</mat-label>
                            <input matInput placeholder="Nombre" name="name" formControlName="name" required>
                        </mat-form-field>

                        <!-- Tipo de proyecto (Task) -->
                        <mat-form-field *ngIf="entity.type.type === 'GeneralTask'" dense appearance="outline" floatLabel="always" class="pl-4 sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5">
                            <mat-label>Tipo</mat-label>
                            <mat-select name="type" [compareWith]="_systemService.compareFunction" formControlName="type" [value]="entity.type">
                                <mat-option *ngFor="let type of _projectTreeService.taskTypes" [value]="type">
                                    {{type.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <!-- Tipo de proyecto (Phase) -->
                        <mat-form-field *ngIf="entity.type.type === 'Phase'" dense appearance="outline" floatLabel="always" class="pl-4 sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5">
                            <mat-label>Tipo</mat-label>
                            <mat-select name="type" [compareWith]="_systemService.compareFunction" formControlName="type" [value]="entity.type" required>
                                <mat-option *ngFor="let type of _projectTreeService.phaseTypes" [value]="type">
                                    {{type.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <!-- Responsable -->
                        <mat-form-field dense appearance="outline" floatLabel="always" class="pl-4 sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5">
                            <mat-label>Responsable</mat-label>
                            <mat-select name="inCharge" [compareWith]="_systemService.compareFunction" formControlName="inCharge" [value]="entity.inCharge">
                                <mat-option *ngFor="let user of users" [value]="user">
                                    {{user.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <!-- Comienzo -->
                        <mat-form-field dense appearance="outline" floatLabel="always" class="pl-4 sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5">
                            <mat-label>Comienzo</mat-label>
                            <input matInput type="date" name="start" formControlName="start">
                        </mat-form-field>

                        <!-- Fin -->
                        <mat-form-field dense appearance="outline" floatLabel="always" class="pl-4 sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5">
                            <mat-label>Fin</mat-label>
                            <input matInput type="date" name="finish" formControlName="finish">
                        </mat-form-field>

                        <!-- Observaciones -->
                        <mat-form-field dense appearance="outline" floatLabel="always" class="pl-4 w-full">
                            <mat-label>Observaciones</mat-label>
                            <textarea matInput cdkTextareaAutosize placeholder="Observaciones" name="description" formControlName="description" cdkAutosizeMinRows="2" cdkAutosizeMaxRows="10"></textarea>
                        </mat-form-field>
                    </div>
                </div>
                <!-- Seguimiento -->
                <div *ngIf="_systemService.visibility.seguimiento" class="flex flex-col mt-6 bg-white shadow-sm border border-slate-200 rounded-lg w-full">
                    <div class="mx-3 mb-0 border-slate-200 pt-3 pb-2 px-1">
                        <span class="text-4xl text-slate-600 font-normal">
                            Seguimiento
                        </span>
                    </div>
                    <div class="flex flex-row pt-2 pr-4 pb-2">
                        <div class="w-full lg:w-3/5 pl-4">
                            <estimation-list #estimationList [entity]="entity" [canModify]="isTask()"></estimation-list>
                        </div>
                        <div class="flex flex-col w-full lg:w-2/5 pl-2">
                            <div class="flex flex-wrap">
                                <!-- estimatedHH -->
                                <mat-form-field dense appearance="outline" floatLabel="always" class="pl-4 sm:w-1/2 md:w-1/3">
                                    <mat-label>HH Estimadas</mat-label>
                                    <input matInput type="number" name="estimatedHH" formControlName="estimatedHH" readonly>
                                </mat-form-field>

                                <!-- actualHH -->
                                <mat-form-field dense appearance="outline" floatLabel="always" class="pl-4 sm:w-1/2 md:w-1/3">
                                    <mat-label>HH Reales</mat-label>
                                    <input matInput type="number" name="actualHH" formControlName="actualHH" readonly>
                                </mat-form-field>

                                <!-- diferenciaHH -->
                                <mat-form-field dense appearance="outline" floatLabel="always" class="pl-4 sm:w-1/2 md:w-1/3">
                                    <mat-label>Diferencia</mat-label>
                                    <input matInput type="number" name="difHH" formControlName="difHH" readonly>
                                </mat-form-field>

                                <!-- Costo estimatedHH -->
                                <mat-form-field dense appearance="outline" floatLabel="always" class="pl-4 sm:w-1/2 md:w-1/3">
                                    <mat-label>Costo HH Estimadas</mat-label>
                                    <input matInput type="number" name="estimatedHHCost" formControlName="estimatedHHCost" readonly>
                                </mat-form-field>

                                <!-- Costo actualHH -->
                                <mat-form-field dense appearance="outline" floatLabel="always" class="pl-4 sm:w-1/2 md:w-1/3">
                                    <mat-label>Costo HH Reales</mat-label>
                                    <input matInput type="number" name="actualHHCost" formControlName="actualHHCost" readonly>
                                </mat-form-field>

                                <!-- diferenciaHH Cost -->
                                <mat-form-field dense appearance="outline" floatLabel="always" class="pl-4 sm:w-1/2 md:w-1/3">
                                    <mat-label>Diferencia</mat-label>
                                    <input matInput type="number" name="difHHCost" formControlName="difHHCost" readonly>
                                </mat-form-field>
                            </div>

                            <div class="flex flex-wrap items-center">
                                <!-- finalizado -->
                                <div class="pl-4 pb-4">
                                    <mat-checkbox #ch (click)="entity.approved=ch.checked" formControlName="approved">
                                        Marcar como finalizado
                                    </mat-checkbox>
                                </div>
                            </div>

                            <div class="flex flex-wrap" *ngIf="entity.approved">
                                <!-- Aprobado por -->
                                <mat-form-field dense appearance="outline" floatLabel="always" class="pl-4 sm:w-1/2">
                                    <mat-label>Aprobado por</mat-label>
                                    <input matInput type="text" name="approvedBy" formControlName="approvedBy" readonly>
                                </mat-form-field>

                                <!-- Fecha de aprobado -->
                                <mat-form-field dense appearance="outline" floatLabel="always" class="pl-4 sm:w-1/2">
                                    <mat-label>Fecha de aprobado</mat-label>
                                    <input matInput type="date" name="approvedDate" formControlName="approvedDate" readonly>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <!-- / CONTENT -->

</div>
<!-- / CONTENT CARD -->

<!-- / CENTER -->

